export const eAnimationNames = {
  EAN_ANTISIPATOR: 'animation'
};

export const eBigWinAnimationNames = {
  IDLE: 'big_win_idle'
};

export const eMegaWinAnimationNames = {
  IDLE: 'mega_win_idle'
};
